import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/companyRest/list',
    method: 'post',
    data,
  })
}

export function getCompanyList(data) {
  return request({
    url: '/api/companyRest/listAll',
    method: 'post',
    data,
  })
}

export function doAdd(data) {
  return request({
    url: '/api/companyRest/',
    method: 'post',
    data,
  })
}

export function doEdit(data) {
  return request({
    url: '/api/companyRest/',
    method: 'put',
    data,
  })
}

export function doDelete(data) {
  return request({
    url: '/api/companyRest/' + data,
    method: 'delete',
  })
}
